<template>
    <ul>
		<li
      v-for="profil in profilName"
      :key="profil.index"
      :value="profil.index"
      :name="profil.position"
      @click="chooseOption(profil.index, profil.item, profil.position)">
        <figure>
          <img :src="require(`../assets/options/${profil.index}-${profil.toggle}.png`)" :alt="profil.item" :title="profil.item" />
        </figure>
    </li>
	</ul>
</template>

<script>
export default {
  name: 'Options',
  data() {
    return {
      profilName: [
        { item: 'Pręt okrągły', index: '1', toggle: 'off', position: 2},
        { item: 'Rura okrągła', index: '2', toggle: 'off', position: 4},
        { item: 'Pręt sześciokątny', index: '3', toggle: 'off', position: 3},
        { item: 'Rura sześciokątna', index: '4', toggle: 'off', position: 5},
        { item: 'Kwadrat', index: '5', toggle: 'off', position: 1},
        { item: 'Blacha / Płaskownik', index: '6', toggle: 'off', position: 6},
        { item: 'Profil zamknięty', index: '7', toggle: 'off', position: 7},
        { item: 'Kątownik', index: '8', toggle: 'off', position: 8},
        { item: 'Ceownik', index: '9', toggle: 'off', position: 9},
        { item: 'Teownik', index: '10', toggle: 'off', position: 10},
        { item: 'Dwuteownik', index: '11', toggle: 'off', position: 11},
      ],
      href: '',
    };
  },
  methods: {
    chooseOption(number, name, position){
      for(let i = 0; i < this.profilName.length; i++){
        if(i == position-1){
          this.profilName[i].toggle = 'on';
          this.$el.childNodes[i].classList.add("active");
        }else{
          this.profilName[i].toggle = 'off';
          this.$el.childNodes[i].classList.remove("active");
        }
      }
      this.$emit('option', number, name);
    },
  },
  beforeMount() {
    function compare(a, b) {
      if (a.position < b.position) { return -1; } else if (a.position > b.position) { return 1; }
      return 0;
    }
    return [
        this.profilName.sort(compare),
    ];
  },
};
</script>

<style scoped>
  ul{
    padding:0;
    display:flex;
    justify-content:center;
    flex-wrap: wrap;
    border-bottom: 2px solid #f2f2f2;
  }
  li{
    list-style: none;

    flex: 1;
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    background: #fff;
  }
  
  li figure{
    max-width: 40px;
    max-height: 40px;
    padding: 10px 5px;
    width: 100%;
  }

  li figure img{
    max-width: 100%;
    height: auto;
  }

  li.active figure{
    background: #fd5f00;
  }
  li:hover{
    cursor:pointer;
  }
  p{display:inline-block;}

  @media(max-width: 400px){
    li{
      flex: 15%;
    }
  }

</style>
